export const SALE_RATE_INDEXING_RULE_LIST_SUCCESS = 'SALE_RATE_INDEXING_RULE_LIST_SUCCESS';
export const CREATE_SALE_RATE_INDEXING_RULE_SUCCESS = 'CREATE_SALE_RATE_INDEXING_RULE_SUCCESS';
export const UPDATE_SALE_RATE_INDEXING_RULE_SUCCESS = 'UPDATE_SALE_RATE_INDEXING_RULE_SUCCESS';
export const REMOVE_SALE_RATE_INDEXING_RULE_SUCCESS = 'REMOVE_SALE_RATE_INDEXING_RULE_SUCCESS';
